import VueRouter from 'vue-router'

import Login from './app/Login'
import Main from './app/Main'
import NotFound from './app/NotFound'
import ResetPassword from './app/ResetPassword'

import Dashboard from './app/main/Dashboard'

import FileView from './app/main/FileView'

import UserView from './app/main/UserView'
import UserEdit from './app/main/UserEdit'

import GroupView from './app/main/GroupView'
import GroupEdit from './app/main/GroupEdit'

import ScheduleView from './app/main/ScheduleView'

export default (Vue, Auth) => {
  Vue.use(VueRouter)

  const router = new VueRouter({
    routes: [
      { path: '/login', component: Login },
      { path: '/change/:hash', component: Login },
      { path: '/resetpassword/:id', component: ResetPassword },
      { path: '/resetpassword', component: ResetPassword },
      { path: '/logout', redirect: () => { Auth.logout(); return { path: '/login' } } },
      { path: '/e/404', component: NotFound },
      {
        path: '/', component: Main, meta: { requiresAuth: true }, children: [
          { path: '', component: Dashboard },
          { path: '404', component: NotFound, props: { isMain: true } },

          { path: 'user/all', component: UserView },
          { path: 'user/group/:groupId', component: UserView, props: { isGroup: true } },
          { path: 'user/edit', component: UserEdit, props: { isSelfEdit: true } },
          { path: 'user/:userId/edit', component: UserEdit },
          { path: 'user/create/:email', component: UserEdit, props: { isCreating: true } },

          { path: 'group/all', component: GroupView },
          { path: 'group/:groupId/edit', component: GroupEdit },
          { path: 'group/create', component: GroupEdit, props: { isCreating: true } },

          { path: 'filetree', component: FileView, props: { isAll: true } },
          { path: 'filetree/:treeId', component: FileView },

          { path: 'schedule', component: ScheduleView },
        ]
      },
      { path: '*', redirect: () => (Auth.authenticated ? { path: '/404' } : { path: '/e/404' }) },
    ],
    mode: 'history'
  })

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!Auth.authenticated) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }
    } else {
      if (Auth.authenticated) {
        next({ path: '/' });
      } else {
        next();
      }
    }
  })

  return router
}